module.exports = __webpack_public_path__ + "img/place_setting.0f33bbc8.jpg";